/**
 * Maps browser locale strings to their most likely local currency.
 * If a locale is not found, defaults to USD (no conversion).
 */
const localeCurrencyMap: Record<string, string> = {
  // English variants
  'en-US': 'USD',
  'en-GB': 'GBP',
  'en-CA': 'CAD',
  'en-AU': 'AUD',
  'en-NZ': 'NZD',
  'en-SG': 'SGD',
  'en-HK': 'HKD',
  'en-IE': 'EUR',

  // Chinese
  'zh-CN': 'CNY',
  'zh-TW': 'TWD',
  'zh-HK': 'HKD',
  'zh-SG': 'SGD',

  // Japanese / Korean
  'ja-JP': 'JPY',
  'ja': 'JPY',
  'ko-KR': 'KRW',
  'ko': 'KRW',

  // European
  'de-DE': 'EUR',
  'de-AT': 'EUR',
  'de-CH': 'CHF',
  'fr-FR': 'EUR',
  'fr-BE': 'EUR',
  'fr-CH': 'CHF',
  'fr-CA': 'CAD',
  'es-ES': 'EUR',
  'es-MX': 'MXN',
  'it-IT': 'EUR',
  'it-CH': 'CHF',
  'nl-NL': 'EUR',
  'nl-BE': 'EUR',
  'pt-PT': 'EUR',
  'pt-BR': 'BRL',

  // Scandinavian
  'sv-SE': 'SEK',
  'sv': 'SEK',
  'nb-NO': 'NOK',
  'nn-NO': 'NOK',
  'no': 'NOK',
  'da-DK': 'DKK',
  'da': 'DKK',

  // Other
  'hi-IN': 'INR',
  'ru-RU': 'RUB',
  'ar-AE': 'AED',
};

/**
 * Detect the user's likely local currency from their browser locale.
 * Falls back to USD if locale is not mapped.
 */
export function detectUserCurrency(): string {
  try {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    if (localeCurrencyMap[locale]) {
      return localeCurrencyMap[locale];
    }
    // Try language-only fallback (e.g. 'ja' from 'ja-JP')
    const lang = locale.split('-')[0];
    if (localeCurrencyMap[lang]) {
      return localeCurrencyMap[lang];
    }
  } catch {
    // Intl not supported
  }
  return 'USD';
}

export default localeCurrencyMap;
